import { createContext } from 'react';

import { defaultConfig } from './default';
import { AppConfig } from './types';

/**
 * Provide a React context to consume the config object
 */
export const ConfigContext = createContext<AppConfig>(defaultConfig);
